import React from "react";
import { useSiteData } from "@/context/SiteDataContext"; // Ensure this is correctly set up for fetching the data
import Title from "@/components/shared/Title";
import Button from "@/components/shared/Button";
import WorkshopCard from "@/components/shared/WorkshopCard"; // Assuming you have a WorkshopCard component for displaying individual workshops
import usePageMetadata from "@/lib/usePageMetadata";

function Workshops() {
  const { siteData, loading } = useSiteData();
  const workshops = siteData?.workshops || [];

  usePageMetadata(
    "Workshops | BioStat",
    "Explore the workshops we offer to enhance your skills in medical statistics.",
  );

  if (loading) {
    return <p className="py-10 text-center">Loading workshops...</p>;
  }

  return (
    <section className="px-4 py-12 text-center md:px-12 xl:px-16">
      <div className="flex flex-col items-center">
        <Title title="Workshops" className="mb-6 xl:mb-12" />
      </div>

      <h2 className="text-dark mb-6 text-2xl font-semibold md:text-4xl xl:mb-12">
        Practical training to help you <br className="hidden lg:block" /> apply
        medical statistics with confidence.
      </h2>

      <div className="grid grid-cols-1 gap-x-24 gap-y-8 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 2xl:gap-16">
        {workshops.map((workshop, index) => (
          <WorkshopCard key={index} workshop={workshop} /> // Using WorkshopCard component
        ))}
      </div>
    </section>
  );
}

export default Workshops;
